import { apiBase, cdnBase } from '@conf';
import { SourceType, InitInfo, TspModule, Region, Fetch, FetchOptions, ApiResponse } from '../types';
import { report } from '../util/mdap';
import { measureTime } from '@/util/measure-time';

export interface TranslationArgs {
  language: string
  type: SourceType
  id: number
  keys?: string
  hash?: string
}

interface APIConstructorOptions {
  env: string
  isMainland: boolean
  region: Region
  fetch: Fetch
}

const promises: Record<string, Promise<ApiResponse<any>>> = {}

const getURL = ({ url, params }: FetchOptions) => {
  const urlObj = new URL(url)
  if (params) {
    for (const key of Object.keys(params)) {
      urlObj.searchParams.append(key, params[key])
    }
  }
  urlObj.searchParams.sort()
  return urlObj.toString()
}

export class API {
  private apiBase: string;
  private cdnBase: string;
  public fetch: Fetch;

  public constructor(options: APIConstructorOptions) {
    const cn = options.isMainland || options.region === 'cn';
    this.apiBase = apiBase(options.env, cn, options.region);
    this.cdnBase = cdnBase(options.env, cn);
    this.fetch = options.fetch;
  }

  @measureTime('5d42f2badb8e75f819c0b005535c8dc3')
  public async init(language: string, mod: TspModule): Promise<InitInfo> {
    try {
      const params = {
        language,
        projectId: mod.projectId,
        resources: mod.resources?.join(';'),
        collections: mod.collections?.join(';')
      }
      const data = await this.fetch({
        url: `${this.apiBase}/init`,
        params,
      });
      report('29e8db23bebcc026a4d7046e47218c1f', 10000);
      return data.body || {};
    } catch (e) {
      report('a1fe13e807065f3490326d2a34936ec6', 0);
      return {};
    }
  }

  public getTranslationFromAPI = async ({ language, type, id, keys, hash }: TranslationArgs) => {
    const params = { [`${type}_id`]: id, language, keys, hash };
    const options = { url: `${this.apiBase}/transify`, params };
    const key = getURL(options);
    if (!promises[key]) {
      promises[key] = this.fetch(options)
    }
    try {
      const res = await promises[key];
      return res;
    } finally {
      delete promises[key];
    }
  }

  public getTranslationFromCDN = (args: TranslationArgs) => {
    const fileName = this.getFileName(args);
    return this.fetch({ url: `${this.cdnBase}/${fileName}` });
  }

  private getFileName({ type, language, id, hash }: TranslationArgs) {
    // 取type的第一个字符
    let t = `${type[0]}_${id}_${language.toLowerCase()}`;
    return hash ? `${t}_${hash}.js` : `${t}.json`;
  }
}
